import React, { useEffect, useId, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { UserPlusIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { POMIAR_PLANOW_WLACZONY } from '../../config/plany'
import { zdarzenie } from '../../lib/pomiar'

/**
 * Okno „Załóż darmowe konto” po wyczerpaniu limitu bez konta (FE-06) albo w miejscu funkcji od konta Free
 * (porównanie ofert, kolejne zestawy). Prowadzi do rejestracji najkrótszą drogą (e-mail, hasło, zgoda) i zapamiętuje
 * miejsce powrotu razem z `#…` (Sprawdź ofertę trzyma oferty w kotwicy adresu), patrz lib/powrotPoRejestracji.
 *
 * `narzedzie` (np. `sprawdzOferte`) tylko do pomiaru, gdy ten zostanie włączony (config/plany.js).
 * `powrot`: własny adres powrotu, gdy stan ekranu nie siedzi w adresie (Sprawdź ofertę koduje wtedy oferty w `#o=`).
 */
const OknoRejestracji = ({
  tytul = 'Załóż darmowe konto',
  opis = 'Darmowe konto nie ma limitów. Wystarczy e-mail i hasło.',
  narzedzie = '',
  powrot = null,
  onZamknij,
}) => {
  const tytulId = useId()
  const zamknijRef = useRef(null)
  const location = useLocation()
  const skad = { from: powrot || location.pathname + location.search + location.hash }

  useEffect(() => {
    if (POMIAR_PLANOW_WLACZONY) zdarzenie('limit_bez_konta', narzedzie)
  }, [narzedzie])

  useEffect(() => {
    zamknijRef.current?.focus()
    const esc = (e) => { if (e.key === 'Escape') onZamknij() }
    document.addEventListener('keydown', esc)
    return () => document.removeEventListener('keydown', esc)
  }, [onZamknij])

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-gray-900/40 p-4 sm:items-center"
         onMouseDown={(e) => { if (e.target === e.currentTarget) onZamknij() }}>
      <div role="dialog" aria-modal="true" aria-labelledby={tytulId}
           className="relative w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-xl dark:bg-gray-900">
        <button ref={zamknijRef} type="button" onClick={onZamknij} aria-label="Zamknij"
                className="absolute right-3 top-3 rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600
                           dark:hover:bg-gray-800">
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-blue-600">
          <UserPlusIcon className="h-6 w-6" aria-hidden="true" />
        </span>
        <h2 id={tytulId} className="text-lg font-bold text-gray-900 dark:text-gray-100">{tytul}</h2>
        <p className="mt-2 text-sm leading-6 text-gray-600 dark:text-gray-300">{opis}</p>

        <Link to="/rejestracja" state={skad}
              className="mt-5 flex w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm
                         font-semibold text-white no-underline shadow-sm hover:bg-blue-500 active:bg-blue-700">
          Załóż darmowe konto
        </Link>
        <p className="mt-3 text-sm text-gray-500">
          Masz już konto?{' '}
          <Link to="/logowanie" state={skad}
                className="font-semibold text-blue-600 underline underline-offset-2 hover:text-blue-700">
            Zaloguj się
          </Link>
        </p>
      </div>
    </div>
  )
}

export default OknoRejestracji
